import React from 'react';
import { CONSTANTS } from '../../constants/constants';

const { USED, NOT_USED } = CONSTANTS.PARTS_USAGE_ANSWER;

// How a component's recorded usage status is listed on its card: one row per unit.
// Kept apart from the card so the per-unit layout can be changed in one place.
const ComponentUsageAnswers = ({ lines, notApplicable, t }) => {
  if (!notApplicable && !lines?.length) return null;

  const answerLabel = (answer) => {
    if (answer === USED) return t('usageUsed');
    if (answer === NOT_USED) return t('usageNotUsed');
    return t('usageNotRecorded');
  };

  const rows = notApplicable
    ? [{ key: 'not-applicable', label: t('usageStatus'), text: t('notApplicable') }]
    : lines.map((line) => ({
        key: line.lineKey,
        label: lines.length > 1 ? `${t('usageStatus')} ${t('usageUnit', { unit: line.unit })}` : t('usageStatus'),
        text: answerLabel(line.answer),
      }));

  return (
    <div className="component-usage-answers">
      {rows.map((row) => (
        <div className="detail-item" key={row.key}>
          <label>{row.label}</label>
          <span data-testid="part-usage-answer">{row.text}</span>
        </div>
      ))}
    </div>
  );
};

export default ComponentUsageAnswers;
